import { mediaQuery } from 'constants/ui';

export const navTabCustomStyles = {
  padding: '0 16px',

  '&[aria-selected="true"] .nav-tab-label': {
    fontWeight: 700,
    color: ({ palette }) => palette.primary.main,
  },
};

export const navTextWrapperStyles = {
  display: 'flex',
  width: '100%',
  overflow: 'hidden',
  alignItems: 'center',
};

export const navTextContentStyles = {
  display: 'flex',
  gap: '4px',
  flex: 1,
  alignItems: 'center',
  position: 'relative',
  height: '100%',
};

export const navTextStyles = {
  maxWidth: '100%',
  width: 'fit-content',
  color: ({ palette }) => palette.text.dark,
  whiteSpace: 'normal',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  textAlign: 'start',
};

export const pendingChangesCounterStyles = {
  flexShrink: 0,
  marginRight: '10px',

  '& .pending-changes-count': {
    fontWeight: 400,
  },
};

export const fixedTrackGroupStyles = {
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',

  [mediaQuery.mobile]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
  [mediaQuery.tablet]: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
};

export const fullRowFieldWrapperStyles = {
  gridColumn: '1 / -1',
};

export const doubleWidthFieldWrapperStyles = {
  gridColumn: 'span 2',

  [mediaQuery.mobile]: {
    gridColumn: 'auto',
  },
};
